"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseModel_1 = require("../BaseModel");
var PubliqGenericModelReserve3 = /** @class */ (function (_super) {
    __extends(PubliqGenericModelReserve3, _super);
    function PubliqGenericModelReserve3(data) {
        var _this = _super.call(this) || this;
        if (data !== undefined) {
        }
        return _this;
    }
    Object.defineProperty(PubliqGenericModelReserve3, "PropertyMap", {
        get: function () {
            return {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PubliqGenericModelReserve3, "Rtt", {
        get: function () {
            return 104;
        },
        enumerable: true,
        configurable: true
    });
    return PubliqGenericModelReserve3;
}(BaseModel_1.default));
exports.default = PubliqGenericModelReserve3;



//////////////////
// WEBPACK FOOTER
// ./node_modules/blockchain-models-ts/bin/models/PubliqGenericModelReserve3.js
// module id = 206
// module chunks = 0 1